import { Warning } from '@/components/ui/Warning'

import { useTranslation } from 'react-i18next'

const SlippageWarning = () => {
  const { t } = useTranslation()
  return <Warning msg={t('tooltip.HIGH_SLIPPAGE')} />
}

export default SlippageWarning
